import type { Nullable } from 'common/types'
import { select } from 'd3'
import type { FC } from 'react'
import { useEffect, useId, useState } from 'react'

import { DEFAULT_GRADIENT_THICKNESS } from '../constants'
import { useLegendContext } from '../context'
import { createGradientRect } from '../helpers'
import type { GradientProps } from '../types'
import { useGradientDefs } from '../useGradientDefs'

export const Gradient: FC<GradientProps> = ({ gradientThickness = DEFAULT_GRADIENT_THICKNESS }) => {
  const id = useId()
  const [containerEl, setContainerEl] = useState<Nullable<SVGGElement>>(null)
  const { height, width, entityId, isHorizontal, palette } = useLegendContext()

  const gradientHeight = isHorizontal ? gradientThickness : height
  const gradientWidth = isHorizontal ? width : gradientThickness

  useEffect(() => {
    const container = select(containerEl)
    const rect = createGradientRect(
      container,
      id,
      gradientWidth,
      gradientHeight,
      isHorizontal,
      entityId,
    )

    return () => {
      rect.remove()
    }
  }, [containerEl, gradientWidth, gradientHeight, id, isHorizontal, entityId])

  useGradientDefs(id, containerEl, palette)

  return <svg ref={setContainerEl} width={gradientWidth} height={gradientHeight} />
}
